import qs from 'qs';

export const parseQuery = (str) => qs.parse(str, { ignoreQueryPrefix: true });
export const stringifyQuery = (obj) =>
  qs.stringify(obj, { arrayFormat: 'brackets' });
export const filterQuery = (obj) =>
  Object.fromEntries(Object.entries(obj).filter(([, value]) => !!value));
